import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DisplayedLogoFetchFailedAction = {
	type: 'DISPLAYED_LOGO_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DisplayedLogoFetchFailedAction => ({
	type: 'DISPLAYED_LOGO_FETCH_FAILED',
	payload,
});
